import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/bikeRepair/page', data, {
    trim: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/business/bikeRepair/deal', data)
}

// 修改
export function getFileList (id) {
  return request.get(`/business/bikeRepair/getFileList/${id}`)
}
